module.exports = __webpack_public_path__ + "img/blockables-instructions-6.8147c7e4.png";